/** @jsx jsx */
import * as React from 'react';
import { jsx } from '@front10/base-elements';
import { Day } from './Day';

interface MemoizedDayProps {
  dayLabel?: string;
  date: Date;
  blackoutDatesIntegration?: boolean;
  fetchBlackoutDates?: any;
  focusedInput?: string | null;
  allowHoverStyleInRange?: boolean;
}

// Memoized Day component to prevent unnecessary re-renders
export const MemoizedDay = React.memo<MemoizedDayProps>(
  ({ date, dayLabel, ...rest }) => {
    return (
      <Day
        date={date}
        dayLabel={dayLabel}
        blackoutDatesIntegration={rest.blackoutDatesIntegration}
        fetchBlackoutDates={rest.fetchBlackoutDates}
        focusedInput={rest.focusedInput}
        allowHoverStyleInRange={rest.allowHoverStyleInRange}
      />
    );
  },
  (prevProps, nextProps) => {
    // Custom comparison function for better performance
    const dateChanged = prevProps.date.getTime() !== nextProps.date.getTime();
    const dayLabelChanged = prevProps.dayLabel !== nextProps.dayLabel;
    const blackoutChanged =
      prevProps.blackoutDatesIntegration !== nextProps.blackoutDatesIntegration;
    const focusedInputChanged = prevProps.focusedInput !== nextProps.focusedInput;
    const allowHoverChanged = prevProps.allowHoverStyleInRange !== nextProps.allowHoverStyleInRange;

    // Only re-render if any of these props actually changed
    return (
      !dateChanged &&
      !dayLabelChanged &&
      !blackoutChanged &&
      !focusedInputChanged &&
      !allowHoverChanged
    );
  }
);

MemoizedDay.displayName = 'MemoizedDay';
